import { ReportType } from './report-type';

export const REPORT_TYPE_SEQUENCE: Partial<Record<ReportType, ReportType[]>> = {
  [ReportType.Sea]: [ReportType.Sea, ReportType.Anchor, ReportType.Drifting, ReportType.Maneuvering],
  [ReportType.Port]: [ReportType.Port, ReportType.Maneuvering],
  [ReportType.Maneuvering]: [
    ReportType.Sea,
    ReportType.Port,
    ReportType.Maneuvering,
    ReportType.Anchor,
    ReportType.Drifting,
  ],
  [ReportType.Anchor]: [ReportType.Port, ReportType.Anchor, ReportType.Drifting, ReportType.Maneuvering],
  [ReportType.Drifting]: [
    ReportType.Sea,
    ReportType.Port,
    ReportType.Maneuvering,
    ReportType.Anchor,
    ReportType.Drifting,
  ],
};

export const ALL_CREATABLE_REPORT_TYPES: ReportType[] = [
  ReportType.Sea,
  ReportType.Port,
  ReportType.Anchor,
  ReportType.Drifting,
  ReportType.Maneuvering,
];
